import React, { useMemo, useRef, useEffect, useState } from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Checkbox, Bubble } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import '@intelligence/components/GenreSelect/components/Checkboxbar/index.scss';

interface ICheckboxbarProps {
  className?: string;
  checkboxListClassName?: string;
  style?: any;
  value?: any;
  indeterminate?: any;
  search?: string;
  showRightArrow?: boolean;
  active?: boolean;
  disabled?: boolean;
  levelItem?: any;
  onChange?: (payload: any) => void;
  onClick?: (payload: any) => void;
}

const CheckBoxBar: React.FC<ICheckboxbarProps> = (props) => {
  const {
    style,
    className,
    showRightArrow = false,
    active = false,
    disabled = false,
    levelItem,
    value,
    indeterminate,
    onChange,
    onClick,
    search,
  } = props;
  const { locale } = useIntl();

  const textRef = useRef(null);
  const [showBubble, setShowBubble] = useState(false);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowed(textRef.current?.scrollWidth > textRef.current?.clientWidth);
    }
  }, []);

  const highlightText = (text: string, search?: string) => {
    if (!search) return text;
    const escapedSearch = search?.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    const regex = new RegExp(`(${escapedSearch})`, 'gi'); // Case-insensitive regex
    const parts = text?.split(regex);
    return (
      <>
        {parts.map((part, index) =>
          regex.test(part) ? (
            <span key={index} style={{ color: '#326ff0' }}>
              {part}
            </span>
          ) : (
            part
          ),
        )}
      </>
    );
  };

  // 实时文本显示，包括搜索与高亮
  const titleCur = useMemo(() => {
    return highlightText(levelItem?.name || '', search);
  }, [search, levelItem, locale]);

  return (
    <div
      style={style}
      className={classnames('intelligence-genre-checkbox-bar', className, { active })}
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) return;
        onClick?.();
      }}
    >
      <Checkbox
        className="genre-checkbox-checkbox"
        disabled={disabled}
        defaultValue={value}
        indeterminate={indeterminate}
        value={value}
        onChange={() => {
          onChange?.(levelItem);
        }}
      />
      <Bubble dark placement="right" visible={showBubble} content={levelItem?.name}>
        <span
          ref={textRef}
          className={classnames('genre-checkbox-label', { 'is-sub': !showRightArrow })}
          onMouseEnter={() => isOverflowed && setShowBubble(true)}
          onMouseLeave={() => setShowBubble(false)}
        >
          {titleCur}
        </span>
      </Bubble>
      {showRightArrow && <SvgIcon type="point-right" className="genre-checkbox-right-icon" />}
    </div>
  );
};

export default CheckBoxBar;
